import { render, staticRenderFns } from "./ChangeReceiveFormDialog.vue?vue&type=template&id=05bb0ae1"
import script from "./ChangeReceiveFormDialog.vue?vue&type=script&lang=ts"
export * from "./ChangeReceiveFormDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports